const LOGIN_TYPE_KEY = 'loginType'

// 当前使用的登录方式，默认为workWechat
export const setLocalLoginType = (newLoginType) => localStorage.setItem(LOGIN_TYPE_KEY, newLoginType)
export const getLocalLoginType = () => localStorage.getItem(LOGIN_TYPE_KEY)
export const removeLocalLoginType = () => localStorage.removeItem(LOGIN_TYPE_KEY)